import React from "react";
import {Button, Column, Columns, Input, Modal, Section, Title} from "@allxsmith/bestax-bulma";
import LoadingSpinner from "../../Utils/Spinner";
import {readableDate} from "../../../utils";


export default function RentalInfoModal({data, loaded, open, setOpen}){

    if(!loaded){
        // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
        return (
            <Modal
                active={open}
                closeOnBlur
                onClose={() => setOpen(false)}
            >
                <Modal.Content>
                    <Section style={{background: "white"}}>
                        <LoadingSpinner/>
                    </Section>
                </Modal.Content>
            </Modal>
        );
    }

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            closeOnBlur
            onClose={() => setOpen(false)}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Rental Info</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Hire Type</label>
                            <Input
                                disabled={true}
                                value={data.rental_type}
                            />
                        </Column>
                        <Column>
                            <label className="label">On Hire Date</label>
                            <Input
                                disabled={true}
                                value={readableDate(data.on_hire_date)}
                            />
                        </Column>
                        <Column>
                            <label className="label">Chargeable Date</label>
                            <Input
                                disabled={true}
                                value={readableDate(data.chargeable_date)}
                            />
                        </Column>
                        <Column>
                            <label className="label">Vehicle</label>
                            <Input
                                disabled={true}
                                value={data.vehicle ? data.vehicle.registration : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Customer</label>
                            <Input
                                disabled={true}
                                value={data.customer ? data.customer.display_name : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Payer</label>
                            <Input
                                disabled={true}
                                value={data.payer ? data.payer.display_name : ""}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => setOpen(false)}
                                isFullWidth
                            >
                                Close
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );


}